import { useState } from 'react';
import { Input, Space, Tag } from '@arco-design/web-react';

/**
 * JsonArrayInput：JSON 字符串数组 ⇄ 标签输入（运营友好编辑）。
 * value=JSON 数组字符串（'' 或 '[]' = 空）；非法 JSON 按逗号/顿号/换行拆分兜底展示。
 * 标签回车/失焦添加（去重、去空），closable 删除；onChange 恒输出合法 JSON 数组字符串。
 */
function parse(v?: string): string[] {
  if (!v) return [];
  const raw = (v || '').trim();
  if (!raw) return [];
  try {
    const a = JSON.parse(raw);
    if (Array.isArray(a)) return a.filter((x) => typeof x === 'string' && x.trim());
  } catch { /* 落到拆分兜底 */ }
  return raw
    .split(/[,，、\n]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export default function JsonArrayInput({
  value,
  onChange,
  placeholder = '输入后回车添加',
  inputWidth = 160,
}: {
  value?: string;
  onChange?: (v: string) => void;
  placeholder?: string;
  inputWidth?: number;
}) {
  const items = parse(value);
  const [text, setText] = useState('');

  const commit = (next: string[]) => {
    onChange?.(next.length ? JSON.stringify(next) : '');
  };
  const add = () => {
    const t = text.trim();
    if (!t) return;
    if (!items.includes(t)) commit([...items, t]);
    setText('');
  };

  return (
    <Space size={[4, 4]} wrap align="center">
      {items.map((t) => (
        <Tag key={t} closable onClose={() => commit(items.filter((x) => x !== t))} size="small">
          {t}
        </Tag>
      ))}
      <Input
        size="small"
        value={text}
        onChange={setText}
        placeholder={placeholder}
        onPressEnter={add}
        onBlur={add}
        style={{ width: inputWidth }}
      />
    </Space>
  );
}
